import { render } from "./CreateDevbox.vue?vue&type=template&id=40299e10&scoped=true"
import script from "./CreateDevbox.vue?vue&type=script&lang=js"
export * from "./CreateDevbox.vue?vue&type=script&lang=js"

import "./CreateDevbox.vue?vue&type=style&index=0&id=40299e10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40299e10"],['__file',"src/Web/scripts/pages/CreateDevbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40299e10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40299e10', __exports__)) {
    api.reload('40299e10', __exports__)
  }
  
  module.hot.accept("./CreateDevbox.vue?vue&type=template&id=40299e10&scoped=true", () => {
    api.rerender('40299e10', render)
  })

}


export default __exports__